import React from 'react';

import Typography from '../../library/typography/typography';

import { isVirtualAssortmentParentProduct } from '../../shared/utils/product/product';

import { Maybe, ProductData } from '../../shared/types/graphql-types';

import './parent-product-message.scss';

export interface ParentProductMessageProps {
  className?: string;
  product?: Maybe<ProductData>;
}

function ParentProductMessage(props: ParentProductMessageProps) {
  const { className, product } = props;
  const isVirtualAssortmentParent = isVirtualAssortmentParentProduct(product);

  if (!isVirtualAssortmentParent) {
    return null;
  }

  return (
    <Typography className={className} styleName="copy">
      Brands may vary based on availability.
    </Typography>
  );
}

export default ParentProductMessage;
